// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"6c582fc1","219":"1edc7d67","267":"da2493fe","638":"c1c2c175"}[chunkId] + ".chunk.css";
};